import { CornerDownLeft, Search } from "lucide-react";

const Key = ({ children, square }: { children: React.ReactNode; square?: boolean }) => (
  <kbd
    className={
      square
        ? "inline-flex h-4 w-4 items-center justify-center rounded bg-white/[0.06] text-[9px]"
        : "inline-flex h-4 items-center justify-center rounded bg-white/[0.06] px-1 text-[9px]"
    }
  >
    {children}
  </kbd>
);

/** Keyboard hints under the results. */
const SearchFooter = () => (
  <div className="relative flex items-center justify-between border-t border-white/[0.06] bg-white/[0.015] px-5 py-2.5 text-[10.5px] text-slate-500">
    <span className="inline-flex items-center gap-3">
      <span className="inline-flex items-center gap-1.5">
        <Key>↑</Key>
        <Key>↓</Key>
        to navigate
      </span>
      <span className="inline-flex items-center gap-1.5">
        <Key square>
          <CornerDownLeft className="h-2 w-2" />
        </Key>
        to select
      </span>
    </span>
    <span className="hidden items-center gap-1.5 sm:inline-flex">
      <Search className="h-3 w-3 text-brand-300" />
      Searches across your entire workspace
    </span>
  </div>
);

export default SearchFooter;
